export const frontmatter = {
    "draft": true,
    "title": "Authentication",
    "description": "Authentication in the OnnIA API.",
    "sidebar_label": "Authentication",
    "sidebar_group": "reference",
    "sidebar_order": 1
}

export const toc = []